// extracted by css-extract-rspack-plugin
export default {"drop":"drop--XJduZhdEJos4NQuy","buttonWrapper":"button-wrapper--g5oNeQ42Et4Uvzza"};